<highcharts-chart [Highcharts]="Highcharts" [options]="options" #chartComp></highcharts-chart>
